import {
  Autocomplete,
  AutocompleteChangeReason,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField
} from "@mui/material";
import { TFunction } from "i18next";
import { useTranslation } from "react-i18next";

type Props = {
  entries: any[];
  subjectEntityName: string;
  defaultValue: string;
  availableEntries: any[];
  currentEntries: any[];
  onChange: (event: SelectChangeEvent) => void;
  onEquipmentChange?: (value: string[], reasons: AutocompleteChangeReason) => void;
};

export const OptionSelect = ({
  entries,
  subjectEntityName,
  defaultValue,
  availableEntries,
  currentEntries,
  onChange,
  onEquipmentChange
}: Props) => {
  const { t } = useTranslation();
  const checkSubjectEntry = subjectEntityName !== "Equipment";

  return (
    <FormControl sx={{ flex: 1 }}>
      {checkSubjectEntry && (
        <>
          <InputLabel id="option-select-inputLabel">{t("SelectSideToolbarLabel")}</InputLabel>
          <Select
            labelId="option-select-label"
            data-testid={"option-select"}
            id="option-select"
            label={subjectEntityName}
            defaultValue={defaultValue}
            onChange={newValue => onChange(newValue)}
          >
            {entries.length === 0 ? (
              <MenuItem disabled>t({`No ${subjectEntityName}`})</MenuItem>
            ) : (
              entries.map(entry => (
                <MenuItem key={entry.id} value={entry.id}>
                  {entry.name}
                  {entry.id === 0 ? "" : ` (${entry.id})`}
                </MenuItem>
              ))
            )}
          </Select>
        </>
      )}
      {!checkSubjectEntry && availableEntries && currentEntries && (
        <Autocomplete
          options={availableEntries}
          filterSelectedOptions
          value={currentEntries}
          onChange={(e, newEquipment, reasons) => onEquipmentChange?.(newEquipment, reasons)}
          isOptionEqualToValue={(option, value) => option.assetRefId === value.assetRefId}
          data-testid="place-equipment-autocomplete"
          disabled={!availableEntries}
          multiple
          disableCloseOnSelect
          id="place-equipment-assignment"
          getOptionLabel={option => generateOptionLabel(option, t)}
          renderInput={params => (
            <TextField {...params} label={t("Equipment")} variant="standard" />
          )}
        />
      )}
    </FormControl>
  );
};

export const generateOptionLabel = (equipment: any, t: TFunction): string => {
  return `${equipment.name} (${equipment.assetRefId ? equipment.assetRefId : t("Null")})`;
};
